import { LoaderComponent } from './loader.component';

export default angular
  .module('sfMobile.components.loader', ['sfMobile.templates'])
  .component('sfLoader', LoaderComponent).name;
